import { t } from '@lingui/macro';
import { MessageDescriptor } from '@lingui/core';

export const tagsTranslate: { [x: string]: MessageDescriptor } = {
  'geoportal-app': t('tags.geoportal-app')`Геопортал`,
  dgearth: t('tags.dgearth')`ЦЗ`,
  terratech: t('tags.terratech')`ЦЗ`,
  kois: t('tags.kois')`ЦЗ`,
};
